import React, { useRef } from 'react';
import { SubscriptionType } from '../types/PartnerTypes';
import { SubscriptionTypes } from '../types/PartnerTypes';
import { FLAVOR } from '../../../Config/firebase';

interface MinimalSubscriptionCarouselProps {
  subscriptions: SubscriptionType[];
  providerId: string;
}



const MinimalSubscriptionCarousel: React.FC<MinimalSubscriptionCarouselProps> = ({ subscriptions, providerId }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const scrollAmount = container.clientWidth * 0.8; // Scroll 80% of container width
      const newScrollPosition = direction === 'left'
        ? container.scrollLeft - scrollAmount
        : container.scrollLeft + scrollAmount;

      container.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      });
    }
  };

  function onClickSubscription(subscription: SubscriptionType) {
    if (FLAVOR === "DEVELOPMENT") {
      if (subscription.subscriptionType === SubscriptionTypes.Monthly) {
        window.location.href = `https://plundrdev.hosaksham.com/join-subscription-monthly/?spid=${providerId}&subid=${subscription.id}`
      } else {
        window.location.href = `https://plundrdev.hosaksham.com/join-subscription-multiMonth?subid=${subscription.id}&spid=${providerId}`;
      }

    } else {
      if (subscription.subscriptionType === SubscriptionTypes.Monthly) {
        window.location.href = `https://www.goplundr.com/join-subscription-monthly/?spid=${providerId}&subid=${subscription.id}`
      } else {
        window.location.href = `https://www.goplundr.com/join-subscription-multiMonth?subid=${subscription.id}&spid=${providerId}`;
      }
    }
  }

  return (
    <div className="mb-8 p-4 sm:p-6 md:p-10 bg-gradient-to-br from-emerald-50 via-teal-50 to-green-50 rounded-xl sm:rounded-2xl md:rounded-3xl border border-emerald-200/30 shadow-sm">
      <div className="relative mb-4 sm:mb-6 md:mb-10">
        <div className="flex items-start justify-between">
          <div className="relative pl-3 sm:pl-5">
            <div className="absolute -left-0 top-1/2 -translate-y-1/2 w-1 h-10 sm:h-12 md:h-16 bg-gradient-to-b from-emerald-500 to-teal-600 rounded-full"></div>
            <div>
              <span className="text-emerald-600 text-xs sm:text-sm font-medium mb-1 block">Discover More</span>
              <h3 className="text-xl sm:text-xl font-rubik text-gray-900 mb-1 sm:mb-2 font-semibold tracking-wide">Premium Subscriptions</h3>
              <p className="text-gray-600 text-xs sm:text-sm">Exclusive access to experiences and member-only benefits</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="p-2 rounded-full hover:bg-emerald-100 transition-colors border border-emerald-200 hover:border-teal-300 hover:scale-105 active:scale-95"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-emerald-600">
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>
            <button
              onClick={() => scroll('right')}
              className="p-2 rounded-full hover:bg-emerald-100 transition-colors border border-emerald-200 hover:border-teal-300 hover:scale-105 active:scale-95"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-emerald-600">
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-emerald-400/30 via-teal-200/20 to-transparent"></div>
      </div>
      <div className="overflow-x-auto hide-scrollbar -mx-2 px-2" ref={scrollContainerRef}>
        <div className="flex gap-2 sm:gap-4 md:gap-3 pb-4">
          {subscriptions.map((subscription, index) => (
            <div
              key={index}
              onClick={() => onClickSubscription(subscription)}
              className="flex-none w-[220px] sm:w-[260px] md:w-[260px] bg-white rounded-xl overflow-hidden border border-emerald-300 shadow-sm hover:shadow-md hover:shadow-emerald-100/40 transition-all duration-300 cursor-pointer group"
            >
              <div className="relative h-32 sm:h-40 overflow-hidden">
                <div className="absolute inset-0 transition-transform duration-500 group-hover:scale-110">
                  <img
                    src={subscription.picture || "https://images.unsplash.com/photo-1464699908537-0954e50791ee?q=80&w=1974&auto=format&fit=crop"}
                    alt={subscription.Name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className={`absolute top-2 right-2 px-2 py-1 rounded-full text-xs font-medium ${subscription.align2monthlyBoundary ? 'bg-emerald-500/90' : 'bg-teal-600/90'
                  } text-white backdrop-blur-sm z-10 shadow-lg`}>
                  {subscription.PaymentCycle}
                </div>
                <div className="absolute inset-x-0 bottom-0 h-24 sm:h-28 bg-gradient-to-t from-black/80 via-black/40 to-transparent z-[1]"></div>
                <div className="absolute bottom-2 left-3 right-3 z-[2]">
                  <h4 className="font-semibold text-sm sm:text-base text-white mb-0.5 line-clamp-1">{subscription.Name}</h4>
                  <p className="text-white/90 text-xs line-clamp-2">{subscription.subscriptionType}</p>
                </div>
              </div>
              <div className="p-3 sm:p-4">
                <div className="space-y-2 sm:space-y-3">
                  <div className="flex items-center gap-1.5 text-gray-800 text-xs bg-emerald-100/70 p-1.5 sm:p-2 rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-emerald-600">
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                    <span className="line-clamp-1">{subscription.placeName}</span>
                  </div>
                  <div className="flex items-center justify-between pt-1">
                    {subscription.subscriptionType === SubscriptionTypes.Monthly ?
                      <div>
                        <span className="text-emerald-600 font-bold text-sm sm:text-base">₹{subscription.Price}</span>
                        <span className="text-[10px] sm:text-xs text-gray-600 ml-1">/ {subscription.PaymentCycle}</span>
                      </div> :
                      <div>
                        <span className="text-[10px] sm:text-xs text-gray-600 mr-1">Starts at</span>
                        <span className="text-emerald-600 font-bold text-sm sm:text-base">₹{subscription?.cyclePriceArray?.[0]?.price}</span>
                      </div>
                    }
                    <button className="bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-3 sm:px-4 py-1.5 rounded-full text-xs font-medium hover:shadow-md hover:shadow-emerald-200 active:scale-95 transition-all duration-300">
                      Subscribe
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MinimalSubscriptionCarousel; 